import {useTranslation} from "react-i18next";
import {useRef, useState} from "react";
import Form from "react-bootstrap/Form";
import Collapse from "react-bootstrap/Collapse";
import {Button, ButtonGroup, Dropdown} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DataRange from "components/datetime/DataRange";
import SearchSelect from "components/selects/SearchSelect";
import moment from "moment";
import AppName from "./AppName";
import {translations} from "./translations";
import useCustomTranslation from "core/customTranslation";

const FormDataModel = {
    username: "",
    action: "",
    level: "",
    model: "",
    date_from: "",
    date_to: "",
};

const HistoryFilters = ({filtersRef}) => {
    const {t} = useTranslation("tables");
    const {t: _tC} = useTranslation("choices");
    const {t: _TC} = useCustomTranslation(translations);
    const [form, setForm] = useState({...FormDataModel});
    const defaultRange = useRef({
        start: moment().subtract(7, "days"),
        end: moment(),
        startString: "",
        endString: "",
    });
    const [dateRangeLabel, setDateRangeLabel] = useState(
        `${defaultRange.current.start.format("DD-MM-YYYY")} | ${defaultRange.current.end.format("DD-MM-YYYY")}`
    );

    useState(() => {
        defaultRange.current.startString = defaultRange.current.start.format("DD-MM-YYYY");

        defaultRange.current.endString = defaultRange.current.end.format("DD-MM-YYYY");

        filtersRef.current.chosen.start_date = defaultRange.current.start.format("YYYY-MM-DD");
        filtersRef.current.chosen.end_date = defaultRange.current.end.format("YYYY-MM-DD");
    }, []);

    const handleInputChange = (key, value) => {
        if (value) {
            filtersRef.current.chosen[key] = value;
        } else {
            delete filtersRef.current.chosen[key];
        }
        setForm({...form, [key]: value.trim()});
    };

    const selectDataRange = (start, end) => {
        const momentStart = moment(start);
        const momentEnd = moment(end);
        setDateRangeLabel(`${momentStart.format("DD-MM-YYYY")} | ${momentEnd.format("DD-MM-YYYY")}`);
        filtersRef.current.chosen.start_date = momentStart.format("YYYY-MM-DD");
        filtersRef.current.chosen.end_date = momentEnd.format("YYYY-MM-DD");
    };

    const clearDateRange = () => {
        setDateRangeLabel(
            `${defaultRange.current.start.format("DD-MM-YYYY")} | ${defaultRange.current.end.format("DD-MM-YYYY")}`
        );
        filtersRef.current.chosen.start_date = defaultRange.current.start.format("YYYY-MM-DD");
        filtersRef.current.chosen.end_date = defaultRange.current.end.format("YYYY-MM-DD");
    };

    const applyAllFilters = () => {
        filtersRef.current.filter();
    };

    const handleClearFilters = () => {
        setForm({...FormDataModel});
        filtersRef.current.clear();
        clearDateRange();
    };

    const actionsOptions = ["de", "cr", "mo", "sd", "pr", "ot", "lg", "cp"];

    const onChangeSelectModel = (e, actionMeta = null) => {
        let value;
        const key = "model";

        if (actionMeta) {
            if (actionMeta.action === "select-option") {
                value = e.value;
            } else {
                value = "";
            }
        } else {
            value = e.target.value;
        }

        handleInputChange(key, value);
    };

    return (
        <Collapse in={true}>
            <div id="filter-collapse">
                <div className="row ">
                    <Button
                        variant="link"
                        type="button"
                        onClick={handleClearFilters}
                        style={{color: "black"}}
                        className="col-1 d-flex align-items-center justify-content-center"
                        title={t("Limpiar")}>
                        <FontAwesomeIcon icon="filter-circle-xmark" />
                    </Button>
                    <div className="col mb-3" style={{maxWidth: "165px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {t("Usuario")}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            value={form.username}
                            onChange={(e) => handleInputChange("username", e.target.value)}
                        />
                    </div>
                    <div className="col mb-3" style={{maxWidth: "165px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {t("Acción")}
                        </label>
                        <Form.Select value={form.action} onChange={(e) => handleInputChange("action", e.target.value)}>
                            <option value="">{_tC("devices.all")}</option>
                            {actionsOptions.map((value) => (
                                <option key={value} value={value}>
                                    {_tC("actions." + value)}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                    <div className="col-3">
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {t("Modelos")}
                        </label>
                        <SearchSelect
                            options={[
                                {value: "", label: _TC("devices.all")},
                                ...AppName.map((value) => ({
                                    value: value,
                                    label: _TC(value),
                                })),
                            ]}
                            placeholder={_TC("select.model")}
                            value={
                                form.model ? {value: form.model, label: _TC(form.model)} : {value: "", label: _TC("devices.all")}
                            }
                            onChange={onChangeSelectModel}
                            isClearable
                            isMulti={false}
                        />
                    </div>
                    <div className="col mb-3" style={{maxWidth: "165px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {t("Nivel")}
                        </label>
                        <Form.Select value={form.level} onChange={(e) => handleInputChange("level", e.target.value)}>
                            <option value="">{_tC("devices.all")}</option>
                            <option value="info">Info</option>
                            <option value="warning">Warning</option>
                            <option value="danger">Danger</option>
                        </Form.Select>
                    </div>
                    <div className="col-2">
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {t("notifications.date_range")}
                        </label>
                        <ButtonGroup className="w-100">
                            <Dropdown className="w-100">
                                <Dropdown.Toggle
                                    variant="Secondary"
                                    id="dropdown-basic"
                                    style={{
                                        border: "1px solid #ced4da",
                                        minWidth: "100%",
                                    }}
                                    className="custom-dropdown-toggle">
                                    <FontAwesomeIcon icon="fa-solid fa-calendar-day" />
                                    <label
                                        style={{
                                            width: "90%",
                                            textAlign: "center",
                                        }}>
                                        {" "}
                                        {dateRangeLabel}
                                    </label>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <DataRange rangeData={selectDataRange} maxSpan={30} maxDate={new Date()} />
                                </Dropdown.Menu>
                            </Dropdown>
                        </ButtonGroup>
                    </div>
                    <div className="col-1 d-flex align-items-center justify-content-center mt-1">
                        <Button
                            variant="link"
                            type="button"
                            onClick={applyAllFilters}
                            className="btn-outline-primary"
                            title={t("Aplicar")}>
                            <FontAwesomeIcon icon="magnifying-glass" />
                        </Button>
                    </div>
                </div>
            </div>
        </Collapse>
    );
};

export default HistoryFilters;
